import { Directive, ElementRef, EventEmitter, HostListener, Output, Renderer2 } from '@angular/core';
import { Store } from '@ngrx/store';
import { OrderingDirections, OrderingOption } from 'generated/graphql-types';
import { RegisterOptions } from '../models/register-options';
import { RegisterView } from '../models/register-view';

@Directive({
   selector: '[ndtSortColumn]',
   host: {
      class: 'lcs-sort-header',
   },
   standalone: false,
})
export class SortDirective extends RegisterView<RegisterOptions, OrderingOption> {
   columns: string[];

   entityName: string;

   // eslint-disable-next-line @typescript-eslint/member-ordering, @angular-eslint/no-output-on-prefix
   @Output() emitter: EventEmitter<any> = new EventEmitter();

   // eslint-disable-next-line @typescript-eslint/member-ordering
   constructor(private targetElem: ElementRef, private _renderer: Renderer2, public store: Store) {
      super(store);
   }

   // eslint-disable-next-line @typescript-eslint/member-ordering
   @HostListener('click')
   sortColumns() {
      const elem = this.targetElem.nativeElement;
      const direction = elem.getAttribute('sortDirection') || elem['sortDirection'];
      const fields = (elem.getAttribute('sortField') as string).split(',').map((f) => f.trim());
      let orderingDirection = OrderingDirections.Asc;
      if (direction === 'Asc') {
         orderingDirection = OrderingDirections.Desc;
      } else if (direction === 'Desc') {
         orderingDirection = OrderingDirections.NotSet;
      }
      const orderingOptions = fields.map((field) => ({
         direction: orderingDirection,
         field,
      }));
      elem.setAttribute('sortDirection', orderingDirection);
      this.emitter.emit(orderingOptions);
   }
}
